/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from "../request";
// @ts-ignore
import makeRequestHook from "../makeRequestHook";

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig["requestDataOptional"] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0" as any;
const devUrl_0_0_0_0 = "" as any;
const prodUrl_0_0_0_0 = "" as any;
const dataKey_0_0_0_0 = "data" as any;

/**
 * 接口 获取所有权限（添加岗位时使用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getAllRoles`
 */
export interface PostGetAllRolesRequest {}

/**
 * 接口 获取所有权限（添加岗位时使用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getAllRoles`
 */
export interface PostGetAllRolesResponse {
  groups: {
    group_id: string;
    p_id: string;
    auth_name: string;
    children: {
      group_id: string;
      p_id: string;
      auth_name: string;
      children: {
        group_id: string;
        p_id: string;
        auth_name: string;
        children: {}[];
      }[];
    }[];
  }[];
}

/**
 * 接口 获取所有权限（添加岗位时使用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getAllRoles`
 */
type PostGetAllRolesRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/getAllRoles",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 获取所有权限（添加岗位时使用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getAllRoles`
 */
const postGetAllRolesRequestConfig: PostGetAllRolesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/pc.Role/getAllRoles",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.raw,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "postGetAllRoles",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 获取所有权限（添加岗位时使用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getAllRoles`
 */
export const postGetAllRoles = /*#__PURE__*/ (
  requestData?: PostGetAllRolesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostGetAllRolesResponse>(
    prepare(postGetAllRolesRequestConfig, requestData),
    ...args,
  );
};

postGetAllRoles.requestConfig = postGetAllRolesRequestConfig;

/**
 * 接口 获取所有权限（添加岗位时使用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getAllRoles`
 */
export const usePostGetAllRoles = /*#__PURE__*/ makeRequestHook<
  PostGetAllRolesRequest,
  PostGetAllRolesRequestConfig,
  ReturnType<typeof postGetAllRoles>
>(postGetAllRoles);

/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getRoles`
 */
export interface PostGetRolesRequest {
  /**
   * 岗位id
   */
  role_id?: string;
}

/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getRoles`
 */
export interface PostGetRolesResponse {
  role: {
    role_id: string;
    role_name: string;
    content: string;
  };
  checked_ids: string[];
  groups: {
    group_id: string;
    p_id: string;
    auth_name: string;
    children: {
      group_id: string;
      p_id: string;
      auth_name: string;
      children: {
        group_id: string;
        p_id: string;
        auth_name: string;
        children: {}[];
      }[];
    }[];
  }[];
}

/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getRoles`
 */
type PostGetRolesRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/getRoles",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getRoles`
 */
const postGetRolesRequestConfig: PostGetRolesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/getRoles",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetRoles",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getRoles`
 */
export const postGetRoles = /*#__PURE__*/ (
  requestData: PostGetRolesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostGetRolesResponse>(
    prepare(postGetRolesRequestConfig, requestData),
    ...args,
  );
};

postGetRoles.requestConfig = postGetRolesRequestConfig;

/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getRoles`
 */
export const usePostGetRoles = /*#__PURE__*/ makeRequestHook<
  PostGetRolesRequest,
  PostGetRolesRequestConfig,
  ReturnType<typeof postGetRoles>
>(postGetRoles);

/**
 * 接口 绑定岗位（后端调用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/bindRoles`
 */
export interface PostBindRolesRequest {
  /**
   * 岗位id
   */
  role_id?: string;
  /**
   * 爆版用户id
   */
  user_id?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 绑定岗位（后端调用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/bindRoles`
 */
export interface PostBindRolesResponse {}

/**
 * 接口 绑定岗位（后端调用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/bindRoles`
 */
type PostBindRolesRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/bindRoles",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 绑定岗位（后端调用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/bindRoles`
 */
const postBindRolesRequestConfig: PostBindRolesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/bindRoles",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBindRoles",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 绑定岗位（后端调用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/bindRoles`
 */
export const postBindRoles = /*#__PURE__*/ (
  requestData: PostBindRolesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostBindRolesResponse>(
    prepare(postBindRolesRequestConfig, requestData),
    ...args,
  );
};

postBindRoles.requestConfig = postBindRolesRequestConfig;

/**
 * 接口 绑定岗位（后端调用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/bindRoles`
 */
export const usePostBindRoles = /*#__PURE__*/ makeRequestHook<
  PostBindRolesRequest,
  PostBindRolesRequestConfig,
  ReturnType<typeof postBindRoles>
>(postBindRoles);

/**
 * 接口 获取用户的权限（编辑用户权限时使用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getUserRoles`
 */
export interface PostGetUserRolesRequest {
  /**
   * 用户id
   */
  user_id?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 获取用户的权限（编辑用户权限时使用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getUserRoles`
 */
export interface PostGetUserRolesResponse {
  checked_ids: string[];
  groups: {
    group_id: string;
    p_id: string;
    auth_name: string;
    children: {
      group_id: string;
      p_id: string;
      auth_name: string;
      children: {
        group_id: string;
        p_id: string;
        auth_name: string;
        children: {
          group_id: string;
          p_id: string;
          auth_name: string;
          children: {}[];
        }[];
      }[];
    }[];
  }[];
}

/**
 * 接口 获取用户的权限（编辑用户权限时使用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getUserRoles`
 */
type PostGetUserRolesRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/getUserRoles",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 获取用户的权限（编辑用户权限时使用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getUserRoles`
 */
const postGetUserRolesRequestConfig: PostGetUserRolesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/pc.Role/getUserRoles",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "postGetUserRoles",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 获取用户的权限（编辑用户权限时使用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getUserRoles`
 */
export const postGetUserRoles = /*#__PURE__*/ (
  requestData: PostGetUserRolesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostGetUserRolesResponse>(
    prepare(postGetUserRolesRequestConfig, requestData),
    ...args,
  );
};

postGetUserRoles.requestConfig = postGetUserRolesRequestConfig;

/**
 * 接口 获取用户的权限（编辑用户权限时使用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/getUserRoles`
 */
export const usePostGetUserRoles = /*#__PURE__*/ makeRequestHook<
  PostGetUserRolesRequest,
  PostGetUserRolesRequestConfig,
  ReturnType<typeof postGetUserRoles>
>(postGetUserRoles);

/**
 * 接口 编辑用户权限提交 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editUserRoles`
 */
export interface PostEditUserRolesRequest {
  /**
   * 用户id
   */
  user_id?: string;
  /**
   * 权限id，逗号隔开
   */
  group_ids?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 编辑用户权限提交 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editUserRoles`
 */
export interface PostEditUserRolesResponse {}

/**
 * 接口 编辑用户权限提交 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editUserRoles`
 */
type PostEditUserRolesRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/editUserRoles",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 编辑用户权限提交 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editUserRoles`
 */
const postEditUserRolesRequestConfig: PostEditUserRolesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/pc.Role/editUserRoles",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "postEditUserRoles",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 编辑用户权限提交 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editUserRoles`
 */
export const postEditUserRoles = /*#__PURE__*/ (
  requestData: PostEditUserRolesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostEditUserRolesResponse>(
    prepare(postEditUserRolesRequestConfig, requestData),
    ...args,
  );
};

postEditUserRoles.requestConfig = postEditUserRolesRequestConfig;

/**
 * 接口 编辑用户权限提交 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editUserRoles`
 */
export const usePostEditUserRoles = /*#__PURE__*/ makeRequestHook<
  PostEditUserRolesRequest,
  PostEditUserRolesRequestConfig,
  ReturnType<typeof postEditUserRoles>
>(postEditUserRoles);

/**
 * 接口 判断是否有权限（后端调用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/authRole`
 */
export interface PostAuthRoleRequest {
  /**
   * 用户id
   */
  user_id?: string;
  /**
   * 接口mca
   */
  mca?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 判断是否有权限（后端调用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/authRole`
 */
export interface PostAuthRoleResponse {}

/**
 * 接口 判断是否有权限（后端调用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/authRole`
 */
type PostAuthRoleRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/authRole",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 判断是否有权限（后端调用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/authRole`
 */
const postAuthRoleRequestConfig: PostAuthRoleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/authRole",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAuthRole",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 判断是否有权限（后端调用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/authRole`
 */
export const postAuthRole = /*#__PURE__*/ (
  requestData: PostAuthRoleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostAuthRoleResponse>(
    prepare(postAuthRoleRequestConfig, requestData),
    ...args,
  );
};

postAuthRole.requestConfig = postAuthRoleRequestConfig;

/**
 * 接口 判断是否有权限（后端调用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/authRole`
 */
export const usePostAuthRole = /*#__PURE__*/ makeRequestHook<
  PostAuthRoleRequest,
  PostAuthRoleRequestConfig,
  ReturnType<typeof postAuthRole>
>(postAuthRole);

/**
 * 接口 获取多个用户的岗位（后端调用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/usersRole`
 */
export interface PostUsersRoleRequest {
  /**
   * 用户id，逗号隔开
   */
  user_ids?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 获取多个用户的岗位（后端调用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/usersRole`
 */
export interface PostUsersRoleResponse {
  list: {
    role_name?: string;
    user_id?: string;
    role_id: string;
  }[];
}

/**
 * 接口 获取多个用户的岗位（后端调用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/usersRole`
 */
type PostUsersRoleRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/usersRole",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 获取多个用户的岗位（后端调用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/usersRole`
 */
const postUsersRoleRequestConfig: PostUsersRoleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/usersRole",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUsersRole",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 获取多个用户的岗位（后端调用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/usersRole`
 */
export const postUsersRole = /*#__PURE__*/ (
  requestData: PostUsersRoleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostUsersRoleResponse>(
    prepare(postUsersRoleRequestConfig, requestData),
    ...args,
  );
};

postUsersRole.requestConfig = postUsersRoleRequestConfig;

/**
 * 接口 获取多个用户的岗位（后端调用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/usersRole`
 */
export const usePostUsersRole = /*#__PURE__*/ makeRequestHook<
  PostUsersRoleRequest,
  PostUsersRoleRequestConfig,
  ReturnType<typeof postUsersRole>
>(postUsersRole);

/**
 * 接口 岗位列表 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/roleList`
 */
export interface PostRoleListRequest {
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 岗位列表 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/roleList`
 */
export interface PostRoleListResponse {
  list: {
    role_id?: string;
    role_name?: string;
    content?: string;
    /**
     * 1是0否
     */
    is_official?: string;
  }[];
}

/**
 * 接口 岗位列表 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/roleList`
 */
type PostRoleListRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/roleList",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 岗位列表 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/roleList`
 */
const postRoleListRequestConfig: PostRoleListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/roleList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postRoleList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 岗位列表 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/roleList`
 */
export const postRoleList = /*#__PURE__*/ (
  requestData: PostRoleListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostRoleListResponse>(
    prepare(postRoleListRequestConfig, requestData),
    ...args,
  );
};

postRoleList.requestConfig = postRoleListRequestConfig;

/**
 * 接口 岗位列表 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/roleList`
 */
export const usePostRoleList = /*#__PURE__*/ makeRequestHook<
  PostRoleListRequest,
  PostRoleListRequestConfig,
  ReturnType<typeof postRoleList>
>(postRoleList);

/**
 * 接口 新增岗位 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/addRole`
 */
export interface PostAddRoleRequest {
  /**
   * 勾选的权限id，逗号隔开
   */
  group_ids?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
  /**
   * 岗位名称
   */
  role_name?: string;
  /**
   * 岗位描述
   */
  content?: string;
}

/**
 * 接口 新增岗位 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/addRole`
 */
export interface PostAddRoleResponse {}

/**
 * 接口 新增岗位 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/addRole`
 */
type PostAddRoleRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/addRole",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 新增岗位 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/addRole`
 */
const postAddRoleRequestConfig: PostAddRoleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/addRole",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddRole",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 新增岗位 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/addRole`
 */
export const postAddRole = /*#__PURE__*/ (
  requestData: PostAddRoleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostAddRoleResponse>(
    prepare(postAddRoleRequestConfig, requestData),
    ...args,
  );
};

postAddRole.requestConfig = postAddRoleRequestConfig;

/**
 * 接口 新增岗位 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/addRole`
 */
export const usePostAddRole = /*#__PURE__*/ makeRequestHook<
  PostAddRoleRequest,
  PostAddRoleRequestConfig,
  ReturnType<typeof postAddRole>
>(postAddRole);

/**
 * 接口 获取菜单或按钮显示列表 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/userRolesTemplateButton`
 */
export interface PostUserRolesTemplateButtonRequest {
  /**
   * 用户id
   */
  user_id?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 获取菜单或按钮显示列表 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/userRolesTemplateButton`
 */
export interface PostUserRolesTemplateButtonResponse {
  keys: {};
}

/**
 * 接口 获取菜单或按钮显示列表 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/userRolesTemplateButton`
 */
type PostUserRolesTemplateButtonRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/userRolesTemplateButton",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 获取菜单或按钮显示列表 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/userRolesTemplateButton`
 */
const postUserRolesTemplateButtonRequestConfig: PostUserRolesTemplateButtonRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/pc.Role/userRolesTemplateButton",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "postUserRolesTemplateButton",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 获取菜单或按钮显示列表 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/userRolesTemplateButton`
 */
export const postUserRolesTemplateButton = /*#__PURE__*/ (
  requestData: PostUserRolesTemplateButtonRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostUserRolesTemplateButtonResponse>(
    prepare(postUserRolesTemplateButtonRequestConfig, requestData),
    ...args,
  );
};

postUserRolesTemplateButton.requestConfig =
  postUserRolesTemplateButtonRequestConfig;

/**
 * 接口 获取菜单或按钮显示列表 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/userRolesTemplateButton`
 */
export const usePostUserRolesTemplateButton = /*#__PURE__*/ makeRequestHook<
  PostUserRolesTemplateButtonRequest,
  PostUserRolesTemplateButtonRequestConfig,
  ReturnType<typeof postUserRolesTemplateButton>
>(postUserRolesTemplateButton);

/**
 * 接口 编辑岗位提交 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editRoles`
 */
export interface PostEditRolesRequest {
  /**
   * 岗位di
   */
  role_id?: string;
  /**
   * 勾选的权限id，逗号隔开
   */
  group_ids?: string;
  /**
   * 店铺id
   */
  shop_id?: string;
  /**
   * 岗位名称
   */
  role_name?: string;
  /**
   * 岗位描述
   */
  content?: string;
}

/**
 * 接口 编辑岗位提交 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editRoles`
 */
export interface PostEditRolesResponse {}

/**
 * 接口 编辑岗位提交 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editRoles`
 */
type PostEditRolesRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/editRoles",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 编辑岗位提交 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editRoles`
 */
const postEditRolesRequestConfig: PostEditRolesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/baob/pc.Role/editRoles",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postEditRoles",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 编辑岗位提交 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editRoles`
 */
export const postEditRoles = /*#__PURE__*/ (
  requestData: PostEditRolesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostEditRolesResponse>(
    prepare(postEditRolesRequestConfig, requestData),
    ...args,
  );
};

postEditRoles.requestConfig = postEditRolesRequestConfig;

/**
 * 接口 编辑岗位提交 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/editRoles`
 */
export const usePostEditRoles = /*#__PURE__*/ makeRequestHook<
  PostEditRolesRequest,
  PostEditRolesRequestConfig,
  ReturnType<typeof postEditRoles>
>(postEditRoles);

/**
 * 接口 初始化岗位（后端调用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/initUserRole`
 */
export interface PostInitUserRoleRequest {
  /**
   * 店铺id,多个店铺逗号隔开
   */
  shop_id?: string;
  /**
   * 当前登录的用户id,爆版都会传,不用特地传
   */
  userId?: string;
}

/**
 * 接口 初始化岗位（后端调用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/initUserRole`
 */
export interface PostInitUserRoleResponse {}

/**
 * 接口 初始化岗位（后端调用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/initUserRole`
 */
type PostInitUserRoleRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/initUserRole",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 初始化岗位（后端调用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/initUserRole`
 */
const postInitUserRoleRequestConfig: PostInitUserRoleRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/pc.Role/initUserRole",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "postInitUserRole",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 初始化岗位（后端调用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/initUserRole`
 */
export const postInitUserRole = /*#__PURE__*/ (
  requestData: PostInitUserRoleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostInitUserRoleResponse>(
    prepare(postInitUserRoleRequestConfig, requestData),
    ...args,
  );
};

postInitUserRole.requestConfig = postInitUserRoleRequestConfig;

/**
 * 接口 初始化岗位（后端调用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/initUserRole`
 */
export const usePostInitUserRole = /*#__PURE__*/ makeRequestHook<
  PostInitUserRoleRequest,
  PostInitUserRoleRequestConfig,
  ReturnType<typeof postInitUserRole>
>(postInitUserRole);

/**
 * 接口 岗位列表（账号管理列表使用） 的 **请求类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/accountRoleList`
 */
export interface PostAccountRoleListRequest {
  /**
   * 店铺id
   */
  shop_id?: string;
}

/**
 * 接口 岗位列表（账号管理列表使用） 的 **返回类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/accountRoleList`
 */
export interface PostAccountRoleListResponse {
  list: {
    role_id?: string;
    role_name?: string;
    content?: string;
    /**
     * 1是0否
     */
    is_official?: string;
  }[];
}

/**
 * 接口 岗位列表（账号管理列表使用） 的 **请求配置的类型**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/accountRoleList`
 */
type PostAccountRoleListRequestConfig = Readonly<
  RequestConfig<
    "http://127.0.0.1:50505/mock/0",
    "",
    "",
    "/baob/pc.Role/accountRoleList",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 岗位列表（账号管理列表使用） 的 **请求配置**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/accountRoleList`
 */
const postAccountRoleListRequestConfig: PostAccountRoleListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/pc.Role/accountRoleList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "postAccountRoleList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 岗位列表（账号管理列表使用） 的 **请求函数**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/accountRoleList`
 */
export const postAccountRoleList = /*#__PURE__*/ (
  requestData: PostAccountRoleListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PostAccountRoleListResponse>(
    prepare(postAccountRoleListRequestConfig, requestData),
    ...args,
  );
};

postAccountRoleList.requestConfig = postAccountRoleListRequestConfig;

/**
 * 接口 岗位列表（账号管理列表使用） 的 **React Hook**
 *
 * @分类 爆版pc权限
 * @请求头 `POST /baob/pc.Role/accountRoleList`
 */
export const usePostAccountRoleList = /*#__PURE__*/ makeRequestHook<
  PostAccountRoleListRequest,
  PostAccountRoleListRequestConfig,
  ReturnType<typeof postAccountRoleList>
>(postAccountRoleList);

/* prettier-ignore-end */
